export const DEFAULT_QUANTITIES = {
  min: 1,
  max: 99
};